@let $state = state();
@let org = organization();

@if ($state.loading) {
  <spinner class="app-fillf"/>
} @else if (org) {
  <app-page [heading]="org.name">
    <ng-template pageTab="General" icon="settings">
      <div class="field-grid">
        <label>Name</label>
        <app-editable-text
          [control]="form.controls.name"
          [editMode]="editMode()"
          placeholder="Organization name"
          (saving)="saveOrganization('name', $event)"
        />

        <label>Description</label>
        <app-editable-text
          [control]="form.controls.description"
          [editMode]="editMode()"
          placeholder="Organization description"
          (saving)="saveOrganization('description', $event)"
        />
      </div>
    </ng-template>

    <ng-template pageTab="Members" icon="people">
      <!-- Members Section -->
      <div class="app-row app-fill-first gapped">
        <h2>Members ({{ members().length }})</h2>
        @if (editMode() !== 'never') {
          <app-button type="new" label="Add Member" (clicked)="openAddMemberDialog()"/>
        }
      </div>

      <div class="app-column gapped">
        @for (member of members(); track member.id) {
          <div class="app-row gapped padded bordered rounded">
            <div class="app-column app-fill">
              <div>{{ member.name }}</div>
              <div class="text-secondary">{{ member.email }}</div>
            </div>
            <div class="app-row-auto gapped">
              @if (editMode() !== 'never') {
                <select
                  [ngModel]="member.role"
                  (change)="updateMemberRole(member, $any($event.target).value)">
                  <option [ngValue]="OrganizationRole.Admin">Admin</option>
                  <option [ngValue]="OrganizationRole.Editor">Editor</option>
                  <option [ngValue]="OrganizationRole.Reader">Reader</option>
                </select>
                <app-button
                  type="delete"
                  transparent
                  description="Remove Member"
                  (clicked)="removeMember(member)"/>
              } @else {
                <span class="text-success">{{ member.role }}</span>
              }
            </div>
          </div>
        }
      </div>
    </ng-template>

    @if (editMode() !== 'never') {
      <ng-template pageTab="Advanced" icon="danger">
        <app-button type="cancel" label="Delete Organization" (clicked)="deleteOrganization()"/>
      </ng-template>
    }
  </app-page>
}

<!-- Add Member Dialog -->
<app-dialog [open]="showAddMemberDialog()" [title]="'Add Member'" (closed)="closeAddMemberDialog()">
  <div dialog-body>
    <div class="field-grid">
      <label for="member-email">Email Address *</label>
      <input
        id="member-email"
        type="email"
        [value]="newMemberEmail()"
        (input)="newMemberEmail.set($any($event.target).value)"
        placeholder="user@example.com"
        [disabled]="isAddingMember()"
        required/>

      <label for="member-role">Role</label>
      <select
        id="member-role"
        [value]="newMemberRole()"
        (change)="newMemberRole.set($any($event.target).value)"
        [disabled]="isAddingMember()">
        <option [value]="OrganizationRole.Reader">Reader</option>
        <option [value]="OrganizationRole.Editor">Editor</option>
        <option [value]="OrganizationRole.Admin">Admin</option>
      </select>
    </div>
  </div>

  <div dialog-footer>
    <app-button type="cancel" (clicked)="closeAddMemberDialog()" [disabled]="isAddingMember()"/>
    <app-button
      type="save"
      [label]="isAddingMember() ? 'Adding...' : 'Add Member'"
      [disabled]="isAddingMember() || !newMemberEmail().trim()"
      (clicked)="addMember()"/>
  </div>
</app-dialog>
